import { createStore } from 'effector';
import { PUBLIC_ORIGIN } from './urls';

export const $seoPublicOrigin = createStore(PUBLIC_ORIGIN);
export const $notFoundPath = createStore<string | null>(null);
